import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JourChome } from 'sirc-lib';
import { environment } from 'projects/sirc-public/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class JourChomeService {
  private url = environment.hrefBase + `/api/referentiel/jour-chome`;

  constructor(private readonly http: HttpClient) { }

  getAll(): Observable<JourChome[]> {
    return this.http.get<JourChome[]>(this.url);
  }
}
